export default __webpack_public_path__ + "logo-AT-desktop.svg";